module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_06.be7dd0e6.jpg";